module.exports = __webpack_public_path__ + "static/media/welcome-actions.1ae82279.png";